// ** React Imports
import { useState } from 'react';
// ** Utils
import { isObjEmpty } from '@utils';

// ** Third Party Components
import * as yup from 'yup';
import { ArrowLeft, ArrowRight, DownloadCloud } from 'react-feather';
import { Formik, Field } from 'formik';

// ** Reactstrap Imports
import { Form, Label, Input, Row, Col, Button, FormFeedback, FormGroup } from 'reactstrap';
import FileUploaderSingle from '@components/input/FileUploaderSingle';
import api from '../../../../../graphql/api';

import Swal from 'sweetalert2';
import withReactContent from 'sweetalert2-react-content';

const MySwal = withReactContent(Swal);

const memberships = [
  {
    label: 'Free',
    value: 'FREE'
  },
  {
    label: 'Premium',
    value: 'PREMIUM'
  }
];

const handleWarning = () => {
  return MySwal.fire({
    title: 'Error!',
    text: ' Por favor carga una imagen antes de continuar.',
    icon: 'error',
    customClass: {
      confirmButton: 'btn btn-primary'
    },
    buttonsStyling: false
  });
};

const RodeSchema = yup.object().shape({
  name: yup.string().required('Este campos es requerido'),
  description: yup.string().required('Este campos es requerido'),
  status: yup
    .string()
    .not(['initial'], 'Por favor seleccione otro estado')
    .required('Este campos es requerido'),
  membership: yup
    .string()
    .not(['initial'], 'Por favor seleccione otro estado')
    .required('Este campos es requerido'),
  cover: yup.string('').notRequired('Este campo es requerido')
});

const CoverUploadComponent = ({ handleChange, values }) => {
  const [avatar, setAvatar] = useState(values.cover ? values.cover : '');
  const [prev] = useState(values.cover ? values.cover : '');
  const [progress, setProgress] = useState({
    per: 0,
    text: '0%',
    started: false
  });
  const handleUpdateState = (value) => {
    const e = {
      target: {
        name: 'cover',
        value
      }
    };
    handleChange(e);
  };

  const handleFileUpload = async (files) => {
    try {
      const data = new FormData();
      data.append('file', files[0]);
      const config = {
        onUploadProgress(progressEvent) {
          const percentCompleted = Math.round(
            (progressEvent.loaded / progressEvent.total) * 100
          );
          const text = `${percentCompleted}%`;
          setProgress({
            per: percentCompleted,
            text,
            started: true
          });
        }
      };
      const res = (await api.post('/roads/file-upload', data, config)).data;
      setAvatar(res.uri);
      handleUpdateState(res.uri);
    } catch (e) {}
  };

  const handleImgChange = () => {
    setAvatar('');
    handleUpdateState('');
  };

  const handleImgReset = () => {
    setAvatar(prev);
    handleUpdateState(prev);
  };

  return (
    <Row>
      {!avatar && (
        <Col>
          <FileUploaderSingle
            handleSubmit={handleFileUpload}
            accept=".jpg,.png,.jpeg"
          >
            <>
              <Label className="form-label fs-6 mb-1" for="cover">
                Sube una caratula
              </Label>
              <div
                className="px-5 py-2 d-flex align-items-center justify-content-center flex-column"
                style={{
                  border: '1px dashed #7367F0',
                  borderRadius: '2.5px'
                }}
              >
                <DownloadCloud size={64} />
                <p className="text-secondary">
                  Suelta archivos aca o{' '}
                  <a href="/" onClick={(e) => e.preventDefault()}>
                    navega
                  </a>
                </p>
                {progress.started && (
                  <div
                    className="progress"
                    style={{ width: '100%', height: 15, bottom: 0 }}
                  >
                    <div
                      className="progress-bar"
                      role="progressbar"
                      style={{
                        background: '#4DFF84',
                        width: `${progress.text}`
                      }}
                      aria-valuenow={progress.per}
                      aria-valuemin={0}
                      aria-valuemax={100}
                    >
                      {progress.text}
                    </div>
                  </div>
                )}
              </div>
            </>
          </FileUploaderSingle>
          {values.cover && (
            <div className="d-flex align-items-center justify-content-center mt-75 ms-1">
              <Button color="danger" size="sm" outline onClick={handleImgReset}>
                Reiniciar
              </Button>
            </div>
          )}
        </Col>
      )}
      {avatar && (
        <Col md={4}>
          <div className="d-flex">
            <div className="me-25">
              <img
                className="rounded me-50"
                src={avatar}
                alt="Generic placeholder image"
                height="250"
                width="250"
              />
              <div className="d-flex align-items-center justify-content-center mt-75 ms-1">
                <Button
                  color="danger"
                  size="sm"
                  outline
                  onClick={handleImgChange}
                >
                  Cambiar
                </Button>
              </div>
            </div>
          </div>
        </Col>
      )}{' '}
    </Row>
  );
};

const RodeDetails = ({
  stepper,
  handleOnSubmit,
  defaultValues,
  editMode = false
}) => {
  const onSubmit = (data, { errors }) => {
    
    if (!data.cover) {
      handleWarning();
      return;
    }
    delete data.episodes;
    if (!errors || isObjEmpty(errors)) {
      handleOnSubmit(
        {
          ...data
        },
        true
      );
      stepper.next();
    }
  };
 
  return (
    <>
      <div className="content-header">
        <h5 className="mb-0">Detalles del Camino</h5>
        <small className="text-muted">Datos básicos del camino</small>
      </div>
      <Formik
        initialValues={{
          ...defaultValues
        }}
        validateOnChange
        validateOnBlur
        validationSchema={RodeSchema}
        onSubmit={onSubmit}
        setField
      >
        {({
          values,
          handleChange,
          handleBlur,
          handleSubmit,
          errors,
          touched
        }) => (
          <Form onSubmit={handleSubmit}>
            <Row>
              <Col md="3" className="mb-1">
                <Label className="form-label" for="name">
                  Titulo
                </Label>
                <Input
                  type="text"
                  name="name"
                  id="name"
                  onChange={handleChange}
                  onBlur={handleBlur}
                  value={values.name}
                  placeholder="Titulo..."
                  invalid={errors.name && true}
                />
                {errors.name && touched.name && (
                  <FormFeedback>Requerido</FormFeedback>
                )}
              </Col>
              <Col md="3" className="mb-1">
                <Label className="form-label" for="description">
                  Descripción corta
                </Label>
                <Input
                  type="text"
                  id="description"
                  name="description"
                  onChange={handleChange}
                  onBlur={handleBlur}
                  value={values.description}
                  placeholder="Escribe la descripcion"
                  invalid={errors.description && true}
                />
                {errors.description && touched.description && (
                  <FormFeedback>Requerido</FormFeedback>
                )}
              </Col>
              <Col md="3" className="mb-1">
                <Label className="form-label" for="status">
                  Estado
                </Label>
                <Input
                  type="select"
                  name="status"
                  id="status"
                  placeholder="Seleccionar Estado"
                  onChange={handleChange}
                  onBlur={handleBlur}
                  value={values.status}
                  invalid={errors.status && true}
                  required
                >
                  <option disabled value="initial">
                    Seleccionar Estado
                  </option>
                  <option value={true}>Activo</option>
                  <option value={false}>Inactivo</option>
                </Input>
                {errors.status && touched.status && (
                  <FormFeedback>Requerido</FormFeedback>
                )}
              </Col>
              <Col md="3" className="mb-1">
                <Label className="form-label" for="activity">
                  Membresia
                </Label>
                <Input
                  type="select"
                  name="membership"
                  id="membership"
                  placeholder="Seleccionar Membresia"
                  onChange={handleChange}
                  onBlur={handleBlur}
                  value={values.membership}
                  invalid={errors.membership && true}
                  required
                >
                  <option disabled value="initial">
                    Seleccionar Membresia
                  </option>
                  {memberships.map((item) => (
                    <option key={item.value} value={item.value}>
                      {item.label}
                    </option>
                  ))}
                </Input>
                {errors.activity && touched.activity && (
                  <FormFeedback>Requerido</FormFeedback>
                )}
              </Col>
            </Row>
            <Row className="mb-1 mt-2">
              <Col md={4}>
                <CoverUploadComponent
                  handleChange={handleChange}
                  values={values}
                />
              </Col>
              <Col md="2" className="mb-1">
              <FormGroup check>
                <Label className="form-label" for="challenge">
                  Challenge
                </Label>
                <Input
                  type="checkbox"
                  name="challenge"
                  id="challenge"
                  onChange={handleChange}
                  onBlur={handleBlur}
                  value={values.challenge}
                  checked={values.challenge}                                    
                />         
                </FormGroup>       
              </Col>
            </Row>
            <div className="d-flex justify-content-between">
              <Button
                type="button"
                color="secondary"
                className="btn-prev"
                outline
                onClick={() => {
                  stepper.previous();
                }}
              >
                <ArrowLeft size={14} className="align-middle me-sm-25 me-0" />{' '}
                <span className="align-middle d-sm-inline-block d-none">
                  Atras
                </span>
              </Button>
              <Button type="submit" color="primary" className="btn-next">
                <span className="align-middle d-sm-inline-block d-none">
                  {editMode ? 'Actualizar' : 'Crear'}
                </span>
                <ArrowRight size={14} className="align-middle ms-sm-25 ms-0" />
              </Button>
            </div>
          </Form>
        )}
      </Formik>
    </>
  );
};

export default RodeDetails;
